<template>
  <!-- 新增角色 -->
  <div class="addRole">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="addForm"
        label-position="rigth"
        label-width="100px"
        :rules="addFormRule"
        ref="addForm"
      >
        <!-- <div class="form-item-wrap">
          <el-form-item label="角色类型" prop="type">
            <el-select
              v-model="addForm.type"
              placeholder="类型"
              style="width: 200px"
              @change="getFunList"
            >
              <el-option label="商城后台" value="B2B"></el-option>
              <el-option label="业务通" value="YWT"></el-option>
            </el-select>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="角色名称" prop="name">
            <el-input
              v-model="addForm.name"
              clearable
              style="width: 200px"
              placeholder="请输入角色名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input-number
              v-model="addForm.sort"
              :controls="false"
              :min="0"
              style="width: 200px; text-align: left"
            ></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="角色机构" prop="entId">
            <el-select
              v-model="addForm.entId"
              placeholder="请选择"
              clearable
              style="width: 200px"
            >
              <el-option
                v-for="(role, index) in organList"
                :key="index"
                :label="role.label"
                :value="role.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述" prop="des">
            <el-input
              v-model="addForm.des"
              clearable
              style="width: 200px"
              placeholder="请输入该角色的备注"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="功能选择" prop="funId">
            <el-scrollbar style="height: 300px; width: 500px">
              <el-table
                :data="funList"
                stripe
                border
                height="500"
                tooltip-effect="dark"
                :row-style="{ color: '#303133' }"
                style="width: 100%"
              >
                <el-table-column
                  label="序号"
                  align="center"
                  type="index"
                  width="70"
                >
                </el-table-column>
                <el-table-column
                  type="expand"
                  label="展开"
                  align="center"
                  width="50"
                >
                  <template slot-scope="props">
                    <el-table
                      :data="props.row.Childrens"
                      stripe
                      border
                      tooltip-effect="dark"
                      style="width: 100%"
                    >
                      <el-table-column
                        align="center"
                        prop="Title"
                        show-overflow-tooltip
                        label="名称"
                      >
                        <template slot-scope="props">
                          <el-checkbox
                            true-label="Y"
                            false-label="N"
                            v-model="props.row.Selected"
                            @change="selectDAndge(props.row)"
                            >{{ props.row.Title }}</el-checkbox
                          >
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="Buttons"
                        show-overflow-tooltip
                        label="按钮名称"
                      >
                        <template slot-scope="props">
                          <div class="buttonssss">
                            <!-- <div> -->
                            <el-checkbox
                              v-for="(item, index) in props.row.Buttons"
                              :key="index"
                              true-label="Y"
                              false-label="N"
                              v-model="item.Selected"
                              >{{ item.Name }}</el-checkbox
                            >
                            <!-- </div> -->
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="Title"
                  show-overflow-tooltip
                  label="名称"
                >
                  <template slot-scope="props">
                    <el-checkbox
                      true-label="Y"
                      false-label="N"
                      @change="AllSelected(props.row)"
                      v-model="props.row.Selected"
                      >{{ props.row.Title }}</el-checkbox
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- <el-tree
                :data="funList"
                show-checkbox
                @check="treeChecked"
                ref="tree"
                node-key="id"
                :default-checked-keys="funDefList"
              >
              </el-tree> -->
            </el-scrollbar>
          </el-form-item>
        </div>
        <div class="form-item-wrap" style="margin-top: 20px">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submitForm">提交</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: "addRole",
  data() {
    return {
      /**新增表单 */
      addForm: {
        name: "",
        id: "",
        // type: "B2B",
        des: "",
        funId: "",
        sort: "",
        entId: "",
      },
      /**新增表单规则 */
      addFormRule: {
        name: [{ required: true, message: "请输入角色名", trigger: "blur" }],
        // type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        entId: [{ required: true, message: "请选择机构", trigger: "blur" }],
      },
      /**功能列表 */
      funList: [],
      funDefList: [],
      organList: [] /**注册机构列表 */,
      roleId: "",
    };
  },
  mounted() {
    //接收role传递参数
    let row = JSON.parse(decodeURIComponent(this.$route.query.row));
    if (row) {
      //将row数据放进表单中
      for (const key in this.addForm) {
        this.addForm[key] = row[key];
      }
      this.roleId = row.id;
    }
    this.getFunList(); //获取功能列表
    this.getOrgan(); //获取机构列表
  },
  methods: {
    /**获取该角色信息 */
    getRoleData() {},
    /**获取功能列表 */
    getFunList() {
      let data = {
        Source: this.addForm.type,
        keyId: this.roleId || "",
      };
      this.$request({
        url: "Role/RoleAdd",
        method: "post",
        data: data,
      })
        .then((res) => {
          this.funList = [];
          if (res.Code) {
            this.funList = res.Menums;
            //一级菜单而二级菜单都加到一起
            // this.recursion(res.Obj, res.RoleList);
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**获取选中的功能 */
    getButtons(buttons = []) {
      return buttons
        .filter(btn => btn.Selected === 'Y')
        .map(btn => btn.Name)
        .join(',');
    },
    /**数据处理函数 */
    recursion(list, arr) {
      let obj = {};
      let objSel = {};
      obj[0] = [];
      for (let i = 0; i < arr.length; i++) {
        objSel[arr[i].MethodId] = true;
      }
      for (let i = 0; i < list.length; i++) {
        if (!obj[list[i].FatherId || 0]) {
          obj[list[i].FatherId || 0] = [];
        }
        obj[list[i].FatherId || 0].push({
          id: list[i].Id,
          label: list[i].Title,
          children: [],
        });
      }
      for (let i = 0; i < obj[0].length; i++) {
        obj[0][i].children = obj[obj[0][i].id];
      }
      for (let i = 0; i < obj[0].length; i++) {
        objSel[obj[0][i].id] = false;
      }
      for (let i = 0; i < list.length; i++) {
        if (objSel[list[i].Id]) {
          this.funDefList.push(list[i].Id);
        }
      }
      this.funList = obj[0];
    },
    /**获取机构列表 */
    getOrgan() {
      this.$request({
        url: "Role/EntidAdd",
        method: "post",
      })
        .then((res) => {
          this.organList = [];
          if (res.Code) {
            for (let i = 0; i < res.Obj.length; i++) {
              this.organList.push({
                label: res.Obj[i].entname,
                value: res.Obj[i].entid,
              });
            }
            //表单机构选择赋初值
            if (!JSON.parse(decodeURIComponent(this.$route.query.row))) {
              this.addForm.entId = this.organList[0].value;
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },

    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          // console.log("功能列表数据结构",this.funList, );
          // let data1 = [];
          // let data2 = [];
          // let data3 = [];
          const methods = [];
          this.funList.forEach((item) => { 
            // console.log('一级菜单:', item.Title, '选中状态:', item.Selected);          
            if (item.Selected == "Y") {
              //处理一级菜单
              methods.push({
                id: item.Id,
                buttons: this.getButtons(item.Buttons || [])
              });
            }
            
            //处理二级菜单
            (item.Childrens || []).forEach(child => {
              console.log('二级菜单:', child.Title, '选中状态:', child.Selected);
              if (child.Selected == "Y") {
                methods.push({
                  id: child.Id,
                  buttons: this.getButtons(child.Buttons || [])
                });
              }
            });
          });
          
          //去重处理
          const seen = new Set();
          // let uniqueData = Array.from(new Set(methods.map(m => m.id)))
          //   .map(id => methods.find(m => m.id === id));
          const uniqueData = methods.filter(item => 
            !seen.has(item.id) && seen.add(item.id)
          );


          let data = {
            roleName: this.addForm.name,
            describe: this.addForm.des,
            sort: this.addForm.sort,
            methods: uniqueData,
            // ids:
            //   this.$refs.tree.getCheckedKeys().join(",") +
            //   "," +
            //   this.$refs.tree.getHalfCheckedKeys().join(","),
            // source: this.addForm.type,
            source: "",
            entId: this.addForm.entId,
            keyId: this.roleId,
          };
          console.log(data, "提交的数据");
          this.$request({
            url: "Role/AddRole",
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.Code) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.goBack(); //返回上一页会自动重置表单
              } else {
                //失败提示
                this.$message({
                  message: res.Msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**重置表单 */
    resetForm() {
      this.$refs["addForm"].resetFields();
      //树形控件也必须重置
      this.$refs["tree"].setCheckedKeys([]);
    },

    /**获取选中权限的id */
    treeChecked() {
      let res = this.$refs.tree.getCheckedKeys();
      this.addForm.funId = res.join(",");
    },

    selectDAndge(row) {
      let Selected = row.Selected;
      if (row.Buttons.length > 0) {
        row.Buttons.forEach((item) => {
          item.Selected = Selected;
        });
      }
    },
    // 选择全部
    AllSelected(row) {
      let Selected = row.Selected;
      if (row.Childrens.length > 0) {
        row.Childrens.forEach((item) => {
          item.Selected = Selected;
          item.Buttons.forEach((i) => {
            i.Selected = Selected;
          });
        });
      }
    },
  },
};
</script>

<style scoped>
*{
  box-sizing: border-box;
}
.addRole {
  width: 100%;
  height: 100%;
}
.buttons {
  display: flex;
}
.buttonssss {
  display: flex;
  flex-wrap: wrap;
  align-self: flex-start;
  flex-direction: column;
  gap: 8px;
  
}
.buttonssss .el-checkbox {
  flex: 1 0 auto;
  min-width: 120px;
  margin-left: 20px;
  text-align: left;
}

</style>
